import { render, staticRenderFns } from "./FileRichArgument.vue?vue&type=template&id=cb4d962e&scoped=true&"
import script from "./FileRichArgument.vue?vue&type=script&lang=js&"
export * from "./FileRichArgument.vue?vue&type=script&lang=js&"
import style0 from "./FileRichArgument.vue?vue&type=style&index=0&id=cb4d962e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4d962e",
  null
  
)

export default component.exports